import { useQuery } from "@tanstack/react-query";
import productApi from "../services/productApi";
import { TProductFilter } from "../../../interfaces/productInterface";
import { IApiPagination } from "../../../interfaces/IPagination";

type UseProductsQueryOptions = {
  enabled?: boolean;
};

// TODO: Remove this and replace the use useProductsDataQuery to useProductsQuery
export const useProductsDataQuery = (opt: UseProductsQueryOptions) => {
  const { enabled = false } = opt;
  return useQuery({
    queryKey: ["products"],
    queryFn: productApi.getProducts,
    staleTime: 1000 * 60, // 1 minute
    enabled,
  });
};
// TODO: Implement Pagination and filtering for products query
/*
export type UseProductQueryParams = {
  filter: ProductPriceHistoryFilterType;
  pagination: IApiPagination;
};

export const useProductsQuery = (opt: UseProductQueryParams) => {
  const { filter, pagination } = opt;
  return useQuery({
    queryKey: ["products", opt],
    queryFn: productApi.getProducts,
    staleTime: 1000 * 60, // 1 minute
  });
};
*/

type UseProductsByCategoriesQueryptions = UseProductsQueryOptions & {
  categories: string[];
};

export const useProductsByCategoriesQuery = (
  opt: UseProductsByCategoriesQueryptions,
) => {
  const { categories, enabled = false } = opt;
  return useQuery({
    queryKey: ["products-by-categories", categories],
    queryFn: () => productApi.getProductsByCategories(categories),
    staleTime: 1000 * 60, // 1 minute
    enabled,
  });
};

export const useProductQuery = (productId?: string) => {
  return useQuery({
    queryKey: ["product", productId],
    queryFn: () => productApi.getProductById(productId),
    staleTime: 1000 * 60, // 1 minute
    enabled: !!productId,
  });
};

export type UseProductsFilterQueryarams = {
  filter: TProductFilter;
  pagination: IApiPagination;
};

export const useProductsFilterQuery = (params: UseProductsFilterQueryarams) => {
  const { filter, pagination } = params;
  return useQuery({
    queryKey: ["products-filter", filter, pagination],
    queryFn: async () => {
      const res = await productApi.getProductsFilter(filter, pagination);
      return res.data;
    },
    staleTime: 1000 * 60, // 1 minute
  });
};
